import React, { FC } from "react";
import { useLocation } from "react-router-dom";
import { defineMessages, useIntl } from "react-intl";
import { Communication } from "@app/provider/profile/types";
import { InfoCard } from "@app/components";
import * as R from "ramda";
import { routes } from "@app/routing";
import { HEAP_EVENTS } from "@app/provider/types";
import { CommunicationsPreferencesForm } from "@app/components/forms";

import "./updateCommunicationForm.scss";
import { Svg } from "@natera/material/lib/svg";
import PreferenceDialogSvg from "@assets/svg/preference-dialog.svg";

const messages = defineMessages({
  updateCommunicationFormTitle: {
    id: "updateCommunicationFormTitle",
    defaultMessage: "Adjust Communication Preferences",
  },
});

export interface UpdateCommunicationFormProps {
  communicationData?: Communication[];
  handleSubmit: (communicationData: Communication[]) => void;
  handleCancel?: () => void;
  notification?: React.ReactNode;
  className?: string;
  showCancelButton?: boolean;
  isLoading?: boolean;
  isProfileSetup?: boolean;
}

const UpdateCommunicationForm: FC<UpdateCommunicationFormProps> = ({
  communicationData,
  handleSubmit,
  handleCancel,
  notification,
  className,
  showCancelButton,
  isLoading,
  isProfileSetup,
}) => {
  const intl = useIntl();
  const location = useLocation();

  const isAccountCreation = R.includes(location.pathname, [
    routes.confirmation,
    routes.setupProfile,
  ]);

  const onSubmit = (communications: Communication[]) => {
    if (isAccountCreation) {
      heap.track(HEAP_EVENTS.upp_communication_pref);
    }

    handleSubmit(communications);
  };
  return (
    <InfoCard
      titleText={
        isProfileSetup
          ? undefined
          : intl.formatMessage(messages.updateCommunicationFormTitle)
      }
      notification={notification}
      className={className}
    >
      {isProfileSetup && (
        <div className="update-communication-form__setup-profile__icon">
          <Svg content={PreferenceDialogSvg} />
        </div>
      )}
      <CommunicationsPreferencesForm
        isProfileSetup={isProfileSetup}
        communicationData={communicationData}
        onSubmit={onSubmit}
        onCancel={handleCancel}
        showCancelButton={showCancelButton}
        isLoading={isLoading}
      />
    </InfoCard>
  );
};

export default UpdateCommunicationForm;
